import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(userInformationStyles, {
    changePasswordLink: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
        },
        css: css`
            color: ${COLORS.primary.base};
            margin-left: 10px;
            text-decoration: underline;

            &:hover,
            &:focus {
                text-decoration: none;
            }
        `,
    },
});
